import { createFileRoute } from "@tanstack/react-router";
import AgentMetricsPage from "@/pages/AgentMetricsPage";

export const Route = createFileRoute("/_app/agent-metrics")({
  component: AgentMetricsPage,
});
